import { useState, useEffect, useRef } from 'react';
import Bredcrum from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import { Tablescom } from '../../components/tablescomp';
import { userservices } from '../../services/userServices';
import { productservices } from '../../services/productServices';
import { Titlebar, Searchbox, Stockstatus, Stockstatusavailability, Importexceldata,Confirmdialog2 } from '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router";
import { supplierservices } from '../../services/supplierServices'
import { StockServices } from '../../services/stockServices';
import { Dialog } from 'primereact/dialog';
import { TabMenu } from 'primereact/tabmenu';
import { exportToExcel } from '../../helpers/exporttoexcel';
import { Toast } from "primereact/toast";
import { convertFileToBase64 } from '../../helpers/base64conversion';
import { FcRefresh } from "react-icons/fc";
import { AiOutlineRetweet } from "react-icons/ai";
import { useFormikContext,useFormik,Field,Formik,Form,FieldArray } from 'formik';
import {Shopifyproductsfetch} from '../../components/artifacts/shopifycomp'; 
import {DynamicHorizontalTable} from '../../components/dynamictables';
import {useStock} from '../../contexts/stockContexts';
import { warehouseService } from '../../services/warehouseService';
import ReceiveStockForm from './components/transferstockReceiveForm';
import { SiTruenas } from 'react-icons/si';


const Stocktransfers = ({ dashboard = false }) => {
  const toast = useRef(null);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [results, setResults] = useState([]);
  const [userloaded, setUserloaded] = useState(true);
  const [stockdialog, setStockDialog] = useState(false);
  const [detailinfo, setDetailinfo] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // 🔄 dynamic page size
  const [quickFilterText, setQuickFilterText] = useState('');
  const [statusset, setStatusset] = useState('all');
  const [status, setStatus] = useState('draft');
  const [visible, setVisible] = useState(false);
  const [popvisible, setPopvisible] = useState(false);
  const [viewvisible, setViewvisible] = useState(false);
  const [filter, setfilter] = useState({ 'fromdate': '', 'todate': '' });
  const [loading, setLoading] = useState(false);
  const [stocktype, setStocktype] = useState('component');
  const {allwarehouses,getallwarehouses} = useStock();
  
  const gridref = useRef();
  const [confirmarchivestate,setconfirm] = useState({
    'popvisible' : false,
    'id':'',
    'stocktype':''
  });
  const [refreshcell,setRefreshCell] = useState('no');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [transfermodalIsOpen, settransferModalIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [transferreceivedmodalIsOpen,settransferRecievedModalIsOpen] = useState({isVisible:false,data:{}});

  const items = [
    {
      label: 'All Transfers',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('all'),
      // template: (item) => itemRenderer(item, 0)
    },
    {
      label: 'Draft',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('draft'),
      // template: (item) => itemRenderer(item, 0)
    },
    {
      label: 'In Transit',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('in_transit'),
      // template: (item) => itemRenderer(item, 0)
    },
    {
      label: 'Received',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('received'),
      //  template: (item) => itemRenderer(item, 1)
    },
    {
      label: 'Cancelled',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('cancelled'),
      //  template: (item) => itemRenderer(item, 1)
    },
  ];

  function handleStockFilter(status) {
    setStatusset(status);
    // getstocks(statusset, currentPage, pageSize);
  }

  useEffect(() => {
    // getstocks(statusset, currentPage, pageSize);
     getallstocktransfers();
  }, [statusset, currentPage, pageSize]);

  useEffect(() => {
    setColDefs(getColDefs(currentPage, pageSize));
  }, [statusset, currentPage, pageSize]);

  useEffect(() => {
  setColDefs(getColDefs(currentPage, pageSize));
  } , [stocktype, statusset]);


  // useEffect(() => {
  //   setColDefs(getColDefs(currentPage, pageSize));
  // }, [statusset]);

  const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const updatestatus = async (value,params) =>{
    let obj = {
        'transfer_no':params.data.transfer_no,
        'status':value
    }
    const response = await warehouseService.updatestocktransferstatus(obj);
    if(response.status == 200){
         toast.current.show({ severity: 'success', summary: 'Stock Updated', detail: response.data.data });
         getallstocktransfers();
    }else{
         toast.current.show({ severity: 'error', summary: 'Stock Not updated', detail: response.data.data });
    }
  }

  const syncstock = async (transferno) =>{
      const response = await warehouseService.syncstocktransfer(transferno);
      if(response.status == 200){
          toast.current.show({ severity: 'success', summary: 'Stock Synced properly', detail: response.data.data });
        //  getallstocktransfers();
      }else{
          toast.current.show({ severity: 'error', summary: 'Stock Not Synced', detail: response.data.data }); 
      }
  }

  const getColDefs = (currentPage, pageSize) => [
    {
      headerName: "SR NO", field: "id", width: 50,
      valueGetter: (params) => {
        return ((currentPage - 1) * pageSize) + params.node.rowIndex + 1;
      },
    },

    { headerName: "Product", field: "product_name",cellStyle: {
        whiteSpace: 'normal',
        lineHeight: '1.4',
        wordBreak: 'break-word',
        display: 'flex',
        alignItems: 'center'
      }, },
    { headerName: "Product Sku", field: "product_sku",cellStyle: {
       
        // whiteSpace: 'normal',
        // lineHeight: '1.4',
        // wordBreak: 'break-word'
      },
      },
    {
      headerName: "Transfer date", field: "transfer_date"
    },
    { headerName: "Batch No", field: "batch_number",headerComponentFramework: () => (
    <div style={{ textAlign: "center", lineHeight: "1.2" }}>
      Batch<br />No
    </div>
  ) },
    {
      headerName: "Transfer Qty", field: "total_transfer_quantity", cellRenderer: (params) => {
        return (
          <>
            <span>{params.data.total_transfer_quantity}</span> &nbsp; 
            {/* <span className='text-success'>({params.data.unit_of_measurement})</span> */}
          </>
        )
      }
    },
    { headerName: "Received qty", field: "received_quantity" },

    
    {
      headerName: "Status", field: "status", cellRenderer: (params) => {
        return (
          <>
            <select
            className="form-control"
            value={params.getValue()}
            onChange={(e) =>{
                // update status in backend
                // console.log("Status changed to: ", e.target.value);  
                updatestatus(e.target.value,params);
            }}
            >
            <option value="draft">Draft</option>
            <option value="in_transit">In Transit</option>
            <option value="received">Received</option>
            <option value="cancelled">Cancelled</option>
            </select>
            {/* <Stockstatus status={params.data.status}  /> */}
            {/* <span className='text-success'>{params.data.stock_status} </span>     */}
          </>
        )
      }
    },
    // { headerName: "Unit",field: "unit_of_measurement",width:100 },
     
    
    // {
    //   headerName: "In Stock", field: "Instock", cellRenderer: (params) => {
    //     return (
    //       <>  
    //         {/* <button className='btn btn-primary btn-xs'><i className='fa fa-upload'></i></button> */}
    //         <div className='clickable' title="Update new Stock" onClick={(e) => navigate('/quickupdatestock', { state: params.data })} ><Stockstatusavailability status={params.data.Instock}/></div>
            
    //         {/* <Stockstatus status={params.data.Instock}/> */}
    //         {/* <span className='text-success'>{params.data.stock_status} </span>     */}
    //       </>
    //     )
    //   }
    // },

    {
      headerName: "Action",
      cellRenderer: (params) => {
        return (
          <>
           {params.data.receive_confirmed ? (<button className='btn btn-xs btn-warning' title='Update Stock' onClick={(e) =>{syncstock(params.data.transfer_no);}}><i className='fa fa-sync'></i></button>) : (<></>)}
            &nbsp;
             &nbsp;

           { params.data.status == 'received' ? (<button className='btn btn-xs btn-primary' title='Update Stock' onClick={(e) =>{settransferRecievedModalIsOpen({isVisible:true,data:params.data});}}><i className='fa fa-edit'></i></button>) : (<></>)}
         
         
            &nbsp;
            {/* {statusset == 'merged' ? (<></>) : (<button class="btn btn-danger btn-xs btn-border-none" onClick={(e) => {e.stopPropagation();confirmarchive(params.data.id,params.data.stocktype)}}><i class="icon icon-trash color-white"></i></button>)} */}
             &nbsp;
           
            <button class="btn btn-success btn-xs btn-border-none" onClick={(e) => { e.stopPropagation();setStockDialog(true); setDetailinfo(params.data); getdetailinfo(params.data);console.log(params.data); }}><i class="icon icon-eye color-white"></i></button>
          </>

        );
      }
    }
  ];

  const getdetailinfo = (data) =>{
      console.log("get detail info");
      console.log(data); 
  }


 const confirmarchive = (id,stocktype) =>{
     setconfirm({
    'popvisible' : true,
    'id':id,
    'stocktype':stocktype
  });
 }

  const archivestock = (id,stocktype) =>{
    StockServices.archivestock(id,stocktype).then((response)=>{
        if(response.status == 200){
            toast.current.show({ severity: 'success', summary: 'Stocks', detail: response.data.data });
            let page = 1;
            let status = 'all';
            let pageSize = '10';
            // getstocks(status,page,pageSize);
        }else{
            toast.current.show({ severity: 'error', summary: 'Stocks', detail: response.data.data });
        }
    }).catch((error)=>{
         toast.current.show({ severity: 'error', summary: 'Stocks', detail: "Error" });
    })
     
  }

  const [colDefs, setColDefs] = useState(getColDefs(1, 5));

  const getRowClass = params => {
    if (params.data.Instock === 'lowstock') {
      return 'low-stock';
    } else if (params.data.Instock === 'instock') {
      return 'in-stock';
    } else if (params.data.Instock === 'outofstock') {
      return 'out-of-stock';
    }
    else if (params.data.Instock === 'overstock') {
      return 'over-stock';
    }else if (params.data.stocktype === 'product'){
      return 'isproduct';  
    }
    return '';
  };


  useEffect(() => {
    getallstocktransfers();
    }, []);

  
  const getallstocktransfers = async () => {
    setUserloaded(true);
    let response = await warehouseService.getallstocktransfers({status:statusset});
    if (response.status == 200) {
      setResults(response.data.data);
    //   setTotalRows(response.data.total);
    //   setCurrentPage(response.data.current_page);
      setUserloaded(false);
    } else {
      setResults([]);
      setUserloaded(false);
    }
  }


  useEffect(()=>{
    setInterval(()=>{
        // getstocks('merged','1','25');
    },5000);  
  },[])


  useEffect(()=>{
    //   getstocks('merged','1','25');
  },[filter])

  const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    // getstocks(statusset, 1, newSize);       // reload with new size
  };

  const uploaddata = async (e) => {
    e.preventDefault();
    setLoading(true); // show loader
    let file = e.target.file.files[0];
    const base64 = await convertFileToBase64(file);
    StockServices.createmultistockupdate(base64).then((response) => {
      if (response.status == 200) {
        setVisible(false);
        setLoading(false); // show loader
        toast.current.show({ severity: 'success', summary: 'Stock Update', detail: response.data.data });
        // getstocks(statusset, currentPage, pageSize);
      } else {
        toast.current.show({ severity: 'error', summary: 'Stock Update', detail: `${response.data.data}` });
        setVisible(false);
        setLoading(true); // show loader
      }
    }).catch((error) => {

    });
  }

  const onHide = () => {
    setVisible(false);
  };


  const handleExport = () => {
    exportToExcel({ data: results, filename: 'stock' });
  }
  const samplepath = "stockupdate.xlsx";

 

 useEffect(()=>{
//    getstocks('merged','1','25');
   setRefreshCell('refresh');
 },[stocktype]);


  const onRowClicked = (event) => {
    setSelectedRow(event.data);
    // console.log(event.data,'row clicked data');
    setModalIsOpen(true);
  };

  const getwarehousesdropdown = (data,selectedRow) =>{
     let obj = [];
    //  console.log(selectedRow.warehouse_location,'selected row in dropdown');
      data.forEach((item)=>{
        if(selectedRow.warehouse_location != item.warehouse_code){
             obj.push(<option value={item.warehouse_code}>{item.name}</option>);
        }
      });
      return obj;
  }

  const handleTransfer = async (values) =>{
      // console.log(values,'transfer values');
      const response = await warehouseService.stocktransfer(values);
      if(response.status == 200){
          toast.current.show({ severity: 'success', summary: 'Stock Transfer', detail: response.data.data });
          settransferModalIsOpen(false);
        //   getstocks(statusset, currentPage, pageSize);
      }else{
          toast.current.show({ severity: 'error', summary: 'Stock Transfer', detail: response.data.data });
      }
  }

  function isupdated(boolean){
    // console.log(boolean,'boolean daat');
     settransferRecievedModalIsOpen({isVisible:boolean}); 
     if(!boolean){
        getallstocktransfers();
     }
  }



  return (
    <>
      <Toast ref={toast} />
      <Importexceldata
        visible={visible}
        onHide={onHide}
        onSubmit={uploaddata}
        samplepath={samplepath}
        loading={loading}
      />

      {dashboard ? (<>
        <div className="col-md-12 mt-3">
          {/* <div className='row'>
            <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
          </div> */}
          <div className='card'>
            <div className='card-body card-body-style'>
              {/* {DisplayComp(activeIndex)} */}
              <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText} paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext}
                handlePrevious={handlePrevious}
                handlePageSizeChange={handlePageSizeChange} gridref={gridref} getRowClass={getRowClass} />
            </div>
          </div>
        </div>
      </>) : (<><Bredcrum title={'Stock Transfers'} divider={false} />
        <div class="row">
          
          <Dialog visible={stockdialog} position='top' modal style={{ width: '80rem' }} onHide={() => { if (!stockdialog) return; setStockDialog(false); }}>
            <div class="container">
              <table className='table-bordered'>
                <tbody>
                  <tr>
                    <th colSpan={9}><h3 className='text-success'>Component Info : </h3></th>
                    
                  </tr>
                  <tr>
                    <th>Product</th>
                    <th>SKU Code</th>
                    <th>Product Type</th>
                    <th>Batch No</th>
                    <th>Quantity</th>
                    <th>Available Quantity</th>
                    <th>Purchase Price</th>
                    <th>Supplier</th>
                    <th>Warehouse</th>
                    <th>Production type</th>
                  </tr>
                  <tr>
                    <td>{detailinfo.product_name}</td>
                    <td>{detailinfo.product}</td>
                    <td>{detailinfo.stocktype}</td>
                    <td>{detailinfo.batch_number}</td>
                    <td>{detailinfo.quantity} <span className='text-success'>({detailinfo.unit_of_measurement})</span></td>
                    <td>{detailinfo.remaining_quantity ? detailinfo.remaining_quantity : detailinfo.quantity}</td>
                    <td>{detailinfo.purchase_price}</td>
                    <td><i className='fa fa-user-circle text-info'></i> &nbsp;{detailinfo.supplier_name}</td>
                    <td><i className='fa fa-map text-warning'></i> {detailinfo.warehouse_location}</td>
                    <td>{detailinfo.production_type}</td>
                  </tr>
                  {/* {displayIngredients()} */}
                </tbody>
              </table>
            </div>
          </Dialog>

          <Confirmdialog2 popvisible={confirmarchivestate.popvisible} setPopvisible={setconfirm} fun={archivestock} id={confirmarchivestate.id} stocktype={confirmarchivestate.stocktype}/>


          <Dialog visible={transfermodalIsOpen} position='top' modal style={{ width: '100rem' }} onHide={() => { if (!transfermodalIsOpen) return; settransferModalIsOpen(false); }}>
            <div class="container">
              <h4>Transfer Stock</h4>
              <p>Source Location:</p>
                  {DynamicHorizontalTable({ data: selectedRow,keysToShow: [
                  "product_name",
                  "product",
                  "supplier_name",

                  "batch_number",
                  "expiry_date",
                  "remaining_quantity",
                  "warehouse_name"
                ] })}

               <br></br>
               <p><b>Destination Location:</b></p>
               {/* {console.log(allwarehouses.data,'all warehouses data')} */}
               <Formik
                    initialValues={{
                      dest_warehouse: "",
                      transfer_quantity: "",
                      receive_confirmed: false,
                      source_warehouse:selectedRow?.warehouse_location,
                      batch_number:selectedRow?.batch_number,
                      remaining_quantity:selectedRow?.remaining_quantity
                    }}
                    // validationSchema={TransferSchema}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      handleTransfer(values);
                      // setSubmitting(false);
                      // resetForm();
                    }}
                  >
                    {({ isSubmitting,setFieldValue,values }) => (
                      <Form style={{ border: "1px solid grey", padding: "10px" }}>
                        <div className="form-group">
                          <label htmlFor="dest_warehouse">Select Warehouse:</label>
                          <Field
                            as="select"
                            name="dest_warehouse"
                            className="form-control"
                            required
                          >
                            <option value="">-- Select Warehouse --</option>
                            {getwarehousesdropdown(allwarehouses.data, selectedRow)}
                          </Field>
                          {/* <ErrorMessage
                            name="dest_warehouse"
                            component="div"
                            className="text-danger text-sm"
                          /> */}
                        </div>

                        <div className="form-group">
                          <label htmlFor="transfer_quantity">Quantity to Transfer:</label>
                          <Field
                            type="number"
                            name="transfer_quantity"
                            className="form-control"
                            min={1}
                            max={selectedRow?.remaining_quantity}
                            required
                            onChange={(e) => {
                              const value = e.target.value; 
                              if (value > selectedRow?.remaining_quantity) {
                                e.target.value = selectedRow?.remaining_quantity;
                                setFieldValue('transfer_quantity', selectedRow?.remaining_quantity);
                              } else  {
                                 setFieldValue('transfer_quantity', value);
                                // e.target.value = 1;
                              }
                            }}
                          />
                          {/* <ErrorMessage
                            name="transfer_quantity"
                            component="div"
                            className="text-danger text-sm"
                          /> */}
                        </div>

                        <div className="form-group">
                        
                          <Field
                            type="hidden"
                            name="source_warehouse"
                            className="form-control"
                          />
                          
                        </div>

                        <div className="form-group">
                        
                          <Field
                            type="hidden"
                            name="source_warehouse"
                            className="form-control"
                          />
                          
                        </div>

                        <div className="form-group">
                        
                          <Field
                            type="hidden"
                            name="remaining_quantity"
                            className="form-control"
                          />
                          
                        </div>

                        <div className="form-group">
                        
                          <Field
                            type="hidden"
                            name="batch_number"
                            className="form-control"
                          />
                        </div>

                        <div className="form-group">
                           <label htmlFor="transfer_quantity">Transfer date:</label> 
                          <Field
                            type="date"
                            name="trasfer_date"
                            className="form-control"
                            required
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="transfer_quantity">Reason:</label>
                          <Field
                            type="text"
                            name="reason"
                            className="form-control"
                          />
                          
                        </div>

                        <div className="form-check mt-2">
                          <Field
                            type="checkbox"
                            name="receive_confirmed"
                            className="form-check-input"
                            id="receive_confirmed"
                          />
                          <label className="form-check-label" htmlFor="receive_confirmed">
                            I confirm that the stock has been received
                          </label>

                          {/* <ErrorMessage
                            name="receive_confirmed"
                            component="div"
                            className="text-danger text-sm"
                          /> */}
                        </div>

                        <button
                          type="submit"
                          className="btn btn-primary mt-2"
                          // disabled={isSubmitting}
                          disabled={isSubmitting || !values.receive_confirmed}
                        >
                          Transfer Stock
                        </button>
                      </Form>
                    )}
                  </Formik>

                  
            </div>
          </Dialog>


          <Dialog visible={modalIsOpen} position='top' modal style={{ width: '100rem' }} onHide={() => { if (!modalIsOpen) return; setModalIsOpen(false); }}>
            <div class="container">
                 {statusset === 'all' ? <button
                      className="btn btn-secondary"
                      onClick={() => {
                        if (window.confirm("Are you sure you want to transfer this stock?")) {
                             settransferModalIsOpen(true);getallwarehouses();
                             
                        }
                      }}
                    >
                      Transfer
                    </button> : <></>}
                
                {DynamicHorizontalTable({ data: selectedRow })}
            </div>
          </Dialog>


          <Dialog visible={transferreceivedmodalIsOpen.isVisible} position='right' modal style={{ width: '30rem' }} onHide={() => { if (!transferreceivedmodalIsOpen.isVisible) return; settransferRecievedModalIsOpen({isVisible:false}); }} header="Receive Stock Transfer">
            <div class="container">
              {/* <h4>Received Stock</h4> */}
              <ReceiveStockForm selectedRow={transferreceivedmodalIsOpen.data} modalshow={isupdated}/>    
            </div>
          </Dialog>

          {/* <Titlebar text={'Stocks'} /> */}
          <div className="col-md-12 mt-2">
            <div className='row'>
              <div className='col-md-10'>
                {/* <select className='rounded w-20 text-brownish dropdown-custom-style mb-2' value={stocktype} onChange={(e) => selectstocktype(e)}>
                  <option value="component">Component</option>
                  <option value="product">Product</option>
                </select>  */}
                <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
              </div>

              <div className='col-md-2 mt-2'>
                <div>
                 {/* <br/> */}
                  <button class="export-btn form-control w-100 pull-right" onClick={() => handleExport()}>
                    <i className='fa fa-file-excel'></i> &nbsp;Export to Excel</button>
                </div>
              </div>
            </div>
            <div className='card'>
              <div className='card-body card-body-style'>
                {/* {DisplayComp(activeIndex)} */}
                <Formik
                initialValues={{}}
                enableReinitialize={true}
                onSubmit={async (values) => {
                    setfilter({ fromdate: values.fromdate, todate: values.todate });
                }}
                >

                <Form>
                    <div className='flex-box pb-3'>
                    <div className='flex-box flex-column date-box-style pb-2'>
                        <div className='pb-2 primary-text-color'><label>From date</label> </div>
                        <Field type="date" name="fromdate" placeholder='From date' className='primary-text-color date-input-style' />
                    </div>
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    

                    <div className='flex-box flex-column date-box-style pb-2'>
                        <div className='pb-2 primary-text-color'><label>To date</label> </div>
                        <Field type="date" name="todate" placeholder='To date' className='primary-text-color date-input-style' />
                    </div>
                    &nbsp;
                    &nbsp;

                    <div className='date-box'>
                        <button type='submit' className='btn-success text-white'>Filter</button>
                    </div>
                    </div>
                </Form>
                </Formik>
                <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText} paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                  totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext}
                  handlePrevious={handlePrevious}
                  handlePageSizeChange={handlePageSizeChange} gridref={gridref} getRowClass={getRowClass} refreshGridcell={refreshcell}/>
              </div>
            </div>
          </div>
        </div></>)}

    </>


  );
}
export default Stocktransfers;